module.exports = __webpack_public_path__ + "static/media/rxr pro xp.c8e84b85.glb";